import { createContext, PropsWithChildren, useContext } from 'react';

const Context = createContext(false);

/** A context provider that gives a hint that we are rendering statically (eg exporting to html) */
export const StaticRenderingContext = (props: PropsWithChildren) => <Context.Provider value={true}>{props.children}</Context.Provider>;

/** A hook to query whether we are statically rendering. The presence of the context will make this return true */
export const useIsStaticRendering = () => {
	const c = useContext(Context);
	return c === true;
};
